import React from "react";
import { Divider, Header, Segment, Table, List } from "semantic-ui-react";

export default function LeadDetailedContactDetails({ cfdb }) {
    const MAX_PREVIEW = 140;
    const isHashLike = (value) => typeof value === "string" && /^[a-f0-9]{32,64}$/i.test(value);
    const hiddenKeyPatterns = [/^wh_/i, /^pys_/i, /^utm_/i, /^fbp$/i, /^fbc$/i];
    const hasHtmlTags = (value) => {
        if (typeof value !== "string") return false;
        return /<[^>]+>/.test(value) || /&lt;[^&]+&gt;/.test(value);
    };
    const isJsonLikeString = (value) => {
        if (typeof value !== "string") return false;
        const trimmed = value.trim();
        if (!trimmed) return false;
        if (
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))
        ) {
            try {
                JSON.parse(trimmed);
                return true;
            } catch (error) {
                return false;
            }
        }
        return false;
    };
    const isJsonValue = (value) => {
        if (Array.isArray(value)) return true;
        if (value && typeof value === "object") return true;
        return isJsonLikeString(value);
    };
    const shouldHideValue = (key, value) => {
        const keyText = (key || "").toString();
        if (hiddenKeyPatterns.some((pattern) => pattern.test(keyText))) return true;
        if (isJsonValue(value)) return true;
        if (hasHtmlTags(value)) return true;
        if (isHashLike(value)) return true;
        return false;
    };
    const buildDisplay = (value) => {
        if (value === null || value === undefined) return { text: "-", isMuted: true };
        if (typeof value === "string") {
            const trimmed = value.trim();
            if (!trimmed) return { text: "-", isMuted: true };
            if (isHashLike(trimmed)) {
                return { text: `hash:${trimmed.slice(0, 8)}...`, fullText: trimmed, isMuted: true };
            }
            if (trimmed.length > MAX_PREVIEW) {
                return { text: `${trimmed.slice(0, MAX_PREVIEW)}...`, fullText: trimmed };
            }
            return { text: trimmed };
        }
        if (typeof value === "number" || typeof value === "boolean") return { text: String(value) };
        if (Array.isArray(value)) {
            if (value.length === 0) return { text: "-", isMuted: true };
            return { text: value.map((item) => String(item)).join(", ") };
        }
        return { text: String(value) };
    };
    const renderCellValue = (key, value) => {
        if (shouldHideValue(key, value)) return null;
        const display = buildDisplay(value);
        const commonStyle = {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxWidth: "520px",
        };
        const title = display.fullText || display.text;
        return (
            <span style={{ ...commonStyle, color: display.isMuted ? "#888" : undefined }} title={title}>
                {display.text}
            </span>
        );
    };
    return (
        <Segment>
            <Header as="h3">Contact Form Data</Header>

            <Divider />

            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Field Name</Table.HeaderCell>
                        <Table.HeaderCell>Field Value</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {cfdb
                        .filter((c) => !shouldHideValue(c.field_name, c.field_value))
                        .map(c => (
                        <Table.Row key={c.id}>
                            <Table.Cell>{c.field_name}</Table.Cell>
                            <Table.Cell>{renderCellValue(c.field_name, c.field_value)}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Segment>
    );
};
